import {SuperStackStatusConfiguration} from "../utils/types";

const BASE_URL = '/services/plugin-stacks-info/stack-status'

export const getConfig = async (): Promise<{ data: SuperStackStatusConfiguration; success: boolean }> => {
    const response = await fetch(BASE_URL+"/config")
    return response.json()
}

export const postConfig = async (
    parameters: SuperStackStatusConfiguration
): Promise<{ data: SuperStackStatusConfiguration; success: boolean }> => {
    const response = await fetch(BASE_URL+"/config", {
        method: 'POST',
        headers: {
            origin: 'same-origin',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(parameters)
    })

    return response.json()
}

export const getLiveUsers = async id => {
    return await fetch(`/rest/user/${id}`).then(response => response.json())
}